/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileEmpty: {
  name: 'file-empty';
  data: string;
} = {
  name: 'file-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.414c0-.081-.005-.162-.015-.242a1.004 1.004 0 0 0-.41-.99 2.004 2.004 0 0 0-.16-.182L14 2.586a1.986 1.986 0 0 0-.182-.161.999.999 0 0 0-.99-.41A2 2 0 0 0 12.586 2H6Zm6 2H6v16h12V10h-4a2 2 0 0 1-2-2V4Zm4.586 4L14 5.414V8h2.586Z" fill="currentColor"/></svg>`,
};
